import { captureException } from "@sentry/react";
import axios from "../common/axios";
import { API_URL, CDN_URL } from "./constants";

function syncUserMetaData(userProfile) {
  axios
    .get(`${API_URL}/v1/chat/conversation.chatwoot.identity`)
    .then((res) => {
      var setUserData = () => {
        try {
          if (
            window.$chatwoot &&
            typeof window.$chatwoot.setUser === "function"
          ) {
            window.$chatwoot.setUser(userProfile._id, {
              name: `${userProfile.firstName} ${userProfile.lastName}`, // Name of the user
              avatar_url: `${CDN_URL}${userProfile.avatar}`, // Avatar URL
              email: userProfile.email, // Email of the user
              phone_number: `+${userProfile.phone}`, // Phone Number of the user
              identifier_hash: res?.data.identifier_hash,
            });
          }
          window.removeEventListener("chatwoot:ready", setUserData);
        } catch (error) {
          console.warn("Failed to set Chatwoot user data:", error);
          captureException(error);
          window.removeEventListener("chatwoot:ready", setUserData);
        }
      };

      if (window.$chatwoot?.hasLoaded) {
        setUserData();
      } else {
        window.addEventListener("chatwoot:ready", setUserData);
      }
    })
    .catch((err) => {
      captureException(err);
    });
}

// Safe wrapper for Chatwoot operations
function safeChatwootCall(operation, ...args) {
  try {
    if (window.$chatwoot && window.$chatwoot.hasLoaded) {
      const method = window.$chatwoot[operation];
      if (typeof method === "function") {
        return method.apply(window.$chatwoot, args);
      } else {
        console.warn(`Chatwoot method "${operation}" is not available`);
      }
    } else {
      console.warn("Chatwoot is not loaded or ready");
    }
  } catch (error) {
    console.warn(`Chatwoot operation "${operation}" failed:`, error);
    captureException(error);
  }
  return null;
}

function safeToggle(action = "open") {
  return safeChatwootCall("toggle", action);
}

function safeToggleBubbleVisibility(action = "show") {
  return safeChatwootCall("toggleBubbleVisibility", action);
}

function safeReset() {
  return safeChatwootCall("reset");
}

export const ChatWootUtils = {
  syncUserMetaData,
  safeChatwootCall,
  safeToggle,
  safeToggleBubbleVisibility,
  safeReset,
};
